// Map tiles are fetched through the GIS proxy (which holds the OS/aerial API
// keys server-side). The proxy is same-origin in deployed environments; locally
// there is no proxy, so point at dev.
const GIS_API_BASE =
  window.location.hostname === 'localhost'
    ? 'https://dev.historicengland.org.uk'
    : '';

export const OS_TILE_URL = `${GIS_API_BASE}/api/gis/GetOsMapRasterTileImage?layer={layer}&z={z}&x={x}&y={y}`;

export const AERIAL_TILE_URL = `${GIS_API_BASE}/api/gis/GetAerialMapRasterTileImage`;

// The proxy only holds imagery up to zoom 19, so tiles stop there
// (maxNativeZoom) while the map itself allows one further zoom step, which
// Leaflet serves by upscaling the level-19 tiles.
export const MAP_MAX_NATIVE_ZOOM = 19;
export const MAP_MAX_ZOOM = MAP_MAX_NATIVE_ZOOM + 1;

export const TILE_SIZE = 256;

export const TILE_CROSS_ORIGIN = 'anonymous';
const PRINT_TILE_MARKER = 'heprint=1';

export function osTileThumb(layer) {
  return `${GIS_API_BASE}/api/gis/GetOsMapRasterTileImage?layer=${layer}&z=7&x=63&y=41`;
}

export function osTileUrl(layer, z, x, y) {
  return OS_TILE_URL.replace('{layer}', layer)
    .replace('{z}', z)
    .replace('{x}', x)
    .replace('{y}', y);
}

// The aerial proxy is bbox-based rather than XYZ, so a tile is addressed by its
// projected extent. Shared by the live tile layer and the print renderer.
export function aerialTileUrl(layerName, bbox) {
  const params = [bbox.min.x, bbox.min.y, bbox.max.x, bbox.max.y].join(',');
  return `${AERIAL_TILE_URL}?layer=${layerName}&bbox=${params}`;
}

export function printTileUrl(url) {
  return `${url}&${PRINT_TILE_MARKER}`;
}
